import { z } from "zod";
import { CommonModels } from "@/data/common/common.models";

export namespace ProjectsModels {
/** 
 * MediaUploadFileRequestSchema 
 * @type { object }
 * @property { string } fileName Original filename. Example: `profile.png` 
 * @property { number } fileSize Original file size in bytes. Minimum: `1`. Example: `1024` 
 * @property { string } mimeType File mime type. Example: `image/png` 
 * @property { string } thumbnailFileName Thumbnail filename. Example: `profile-thumb.png` 
 * @property { number } thumbnailFileSize Thumbnail file size in bytes. Minimum: `1`. Example: `512` 
 * @property { string } thumbnailMimeType Thumbnail mime type (defaults to mimeType). Example: `image/png` 
 */
export const MediaUploadFileRequestSchema = z.object({ fileName: z.string(), fileSize: z.number().gte(1), mimeType: z.string().nullish(), thumbnailFileName: z.string().nullish(), thumbnailFileSize: z.number().gte(1).nullish(), thumbnailMimeType: z.string().nullish() });
export type MediaUploadFileRequest = z.infer<typeof MediaUploadFileRequestSchema>;


/** 
 * CreateProjectDtoSchema 
 * @type { object }
 * @property { string } description  
 * @property { string[] } mediaIds Media ids 
 * @property { string } title  
 * @property { boolean } featured  
 */
export const CreateProjectDtoSchema = z.object({ description: z.string().nullish(), mediaIds: z.array(z.string()).nullish(), title: z.string(), featured: z.boolean() });
export type CreateProjectDto = z.infer<typeof CreateProjectDtoSchema>;


/** 
 * UpdateProjectDtoSchema 
 * @type { object }
 * @property { string[] } mediaIds Media ids 
 * @property { string } title  
 * @property { string } description  
 * @property { boolean } featured  
 */
export const UpdateProjectDtoSchema = z.object({ mediaIds: z.array(z.string()).nullish(), title: z.string(), description: z.string(), featured: z.boolean() });
export type UpdateProjectDto = z.infer<typeof UpdateProjectDtoSchema>;


/** 
 * ProjectMediaDeletedDtoSchema 
 * @type { object }
 * @property { string } id  
 */
export const ProjectMediaDeletedDtoSchema = z.object({ id: z.string() });
export type ProjectMediaDeletedDto = z.infer<typeof ProjectMediaDeletedDtoSchema>;


/** 
 * ProjectsGetResponseSchema 
 * @type { object }
 * @property { object[] } order List of order definitions 
 * @property { number } page 1-indexed page number to begin from 
 * @property { string } cursor ID of item to start after 
 * @property { string } nextCursor Cursor for next set of items 
 * @property { number } limit Items per response 
 * @property { number } totalItems Total available items 
 * @property { CommonModels.ProjectWithMediaDto[] } items  
 */
export const ProjectsGetResponseSchema = z.object({ ...CommonModels.PaginationDtoSchema.shape, ...z.object({ items: z.array(CommonModels.ProjectWithMediaDtoSchema).nullable() }).partial().shape });
export type ProjectsGetResponse = z.infer<typeof ProjectsGetResponseSchema>;


/** 
 * ProjectsGetMediaResponseSchema 
 * @type { array }
 */
export const ProjectsGetMediaResponseSchema = z.array(CommonModels.ProjectMediaDtoSchema);
export type ProjectsGetMediaResponse = z.infer<typeof ProjectsGetMediaResponseSchema>;


}
